// "/marcas-dportenis?offset=0&facet=manufacturer.raw%3A%22adidas%22"
// { pathname: 'marcas-dportenis', query: { offset: 0, facet: 'manufacturer.raw%3A%22adidas%22' } }
export const formatHref = (href: string) => {
	const _href = decodeURI(href);
	const [pathname, query] = _href.split('?');
	const queryParams = query?.split('&').map((param) => param.split('=')) ?? [];
	return { pathname, query: Object.fromEntries(queryParams) };
};
